var _defs, _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1000",
    width: 1200,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HUMECO-SOLUTIONS-PTY-LTD-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 168.6,
    y1: 542.2,
    x2: 168.6,
    y2: 726.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26abe1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 372,
    y1: 542.2,
    x2: 372,
    y2: 726.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26abe1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 630,
    y1: 542.2,
    x2: 630,
    y2: 726.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26abe1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 804.2,
    y1: 542.2,
    x2: 804.2,
    y2: 726.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26abe1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 992.5,
    y1: 542.2,
    x2: 992.5,
    y2: 726.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26abe1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 1202.7,
    y1: 542.2,
    x2: 1202.7,
    y2: 726.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26abe1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 43.9,
    y1: 533.7,
    x2: 100.8,
    y2: 533.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26abe1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 536.1,
    y1: 68.4,
    x2: 1003.8,
    y2: 68.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26abe1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 175.2,
    y1: 122.4,
    x2: 487.8,
    y2: 122.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ec1e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 516.2,
    y1: 41.5,
    x2: 1024.8,
    y2: 41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ec1e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 470,
    y1: 517.2,
    x2: 471.8,
    y2: 394.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26abe1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 453.1,
    y1: 911.9,
    x2: 453.1,
    y2: 702.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26abe1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 403.9,
    y1: 916.2,
    x2: 403.9,
    y2: 699.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ec1e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: -2.7,
    y1: 487.1,
    x2: -2.7,
    y2: 324.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ec1e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 326.1,
    y1: 919.1,
    x2: 326.1,
    y2: 697.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26abe1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 498.2,
    y1: 729.5,
    x2: 498.2,
    y2: 755.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ec1e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 154.3,
    y1: 729.5,
    x2: 154.3,
    y2: 755.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ec1e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x1: 1202.7,
    y1: 706.2,
    x2: 1202.7,
    y2: 778.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ec1e24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 62,
    y1: 321.6,
    x2: 491.5,
    y2: 51.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26abe1"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: url(#g1) } \n\t\t.s1 { fill: url(#g2) } \n\t\t.s2 { fill: url(#g3) } \n\t\t.s3 { fill: url(#g4) } \n\t\t.s4 { fill: url(#g5) } \n\t\t.s5 { fill: url(#g6) } \n\t\t.s6 { fill: url(#g7) } \n\t\t.s7 { fill: url(#g8) } \n\t\t.s8 { fill: url(#g9) } \n\t\t.s9 { fill: url(#g10) } \n\t\t.s10 { fill: url(#g11) } \n\t\t.s11 { fill: url(#g12) } \n\t\t.s12 { fill: url(#g13) } \n\t\t.s13 { fill: url(#g14) } \n\t\t.s14 { fill: #ffffff } \n\t\t.s15 { fill: url(#g15) } \n\t\t.s16 { fill: url(#g16) } \n\t\t.s17 { fill: url(#g17) } \n\t\t.s18 { fill: url(#g18) } \n\t\t.s19 { fill: url(#g19) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s0",
    d: "m165.9 555.6v136.6h-42.1v-52.6h-81.3v52.6h-42.5v-136.6h42.5v48.4h81.3v-48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s1",
    d: "m369.3 555.6v77c0 41.3-28.4 61.9-85.2 61.9-65.8 0-94.2-20.6-94.2-61.9v-77h42.1v77c0 20.3 8.6 26.8 52.1 26.8 32.5 0 42.7-7.6 42.7-26.8v-77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s2",
    d: "m627.3 692.2h-42.1l-12.9-47.5c-4.3-15.6-7.1-26.6-9.4-37.6-4.5 9.6-9.6 20-19 37.8l-18.3 34.3c-7.2 13.5-14.2 15.3-24.4 15.3-10.2 0-17.1-1.8-24.3-15.3l-18.4-34.5c-10-18.8-14.9-28.4-19.1-37.6-2.1 10.8-5.2 22.3-9.3 37.6l-12.8 47.5h-41.5l35.3-120c3.8-12.7 13.3-18.8 23.9-18.8 10.9 0 18.2 5.5 23.1 14.4l21.9 38.7c12 21 17.3 31.2 22.1 40.8 4.4-9.6 9.8-19.6 21.8-40.6l21.9-38.9c4.9-8.7 12.2-14.4 23.3-14.4 10.6 0 20 6.1 23.6 18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s3",
    d: "m801.5 657.1l-27.2 35.1h-131.5v-136.6h158.3l-27.4 35.6h-88.4v16.3h108.2l-24.3 31h-83.9v18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s4",
    d: "m894 657.1h95.8l-27.2 35.1h-68.6c-47.4 0-82.3-30-82.3-69.6 0-40.1 34.9-67 82.3-67h95.8l-27.2 35.6h-68.6c-22.9 0-40 13.7-40 33.3 0 19.3 16.9 32.6 40 32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m1200 623.8c0 48.8-33.5 70.7-99.9 70.7-66.6 0-99.9-21.9-99.9-70.7 0-48.8 33.3-70.4 99.9-70.4 66.4 0 99.9 21.6 99.9 70.4zm-42.1 0c0-29.4-15.3-34.9-57.8-34.9-42.5 0-57.8 5.5-57.8 34.9 0 29.5 15.3 35.1 57.8 35.1 42.5 0 57.8-5.6 57.8-35.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m100.8 536.5v2.5h-56.9v-0.7c16-0.6 35.5-1.2 56.9-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m1003.8 324.4v213.4h-41.3v-126.2l-0.1-62.1-356.3-228.1-47.6 29.4c0 0 0-0.1-0.1-0.1-5.8-9.4-11.6-19.2-16.6-28.3-1.6-2.9-3.5-5.7-5.7-8.2l69.6-43z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m480.4 126.9c3.2 1.2 5.7 2.8 7.4 4.8l-6.2 3.8-7 4.3-13.9 8.7-7 4.3-6.9 4.3-7 4.3-6.9 4.3-7 4.3-7 4.3-7 4.4-6.9 4.3-7 4.3-7 4.3-6.9 4.3-7 4.3-7 4.3-6.9 4.3-13.9 8.6-7 4.3-7 4.4-6.9 4.3-7 4.3-7 4.2-6.9 4.4-7 4.3-6.9 4.3-7 4.3-7 4.3-13.9 8.6-7 4.3-6.9 4.3-7 4.4-7 4.3-6.9 4.3-7 4.3-13.9 8.6-7 4.3-7 4.3-6.9 4.3-1.9 1.2v217.4h-12v-224.5l13.9-8.6 6.9-4.3 7-4.3 7-4.3 6.9-4.4 7-4.3 7-4.3 6.9-4.3 7-4.3 7-4.3 6.9-4.3 7-4.3 7-4.3 6.9-4.3 7-4.3 7-4.4 6.9-4.3 7-4.3 6.9-4.3 7-4.3 7-4.3 6.9-4.3 7-4.3 7-4.3 6.9-4.4 7-4.2 6.9-4.3 7-4.4 7-4.3 6.9-4.3 7-4.3 7-4.3 6.9-4.3 7-4.3 7-4.3 7-4.3 6.9-4.4 7-4.2 6.9-4.4 7-4.3 7-4.3 6.9-4.3 0.3-0.2q2.9 0.8 5.5 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m1024.8 310.7v227.1h-7l-5-0.8v-219.3l-1.9-1.2-20.9-13.3-6.9-4.5-7-4.4-14-8.8-6.9-4.5-7-4.4-6.9-4.4-7-4.5-7-4.4-7-4.4-6.9-4.4-7-4.4-6.9-4.5-7-4.4-13.9-8.9-7-4.4-13.9-8.8-7-4.5-7-4.4-20.8-13.3-7-4.4-7-4.4-6.9-4.4-7-4.5-7-4.4-13.9-8.9-7-4.4-7-4.4-6.9-4.5-13.9-8.8-7-4.4-6.9-4.5-7-4.4-7-4.5-7-4.3-6.9-4.5-7-4.4-6.9-4.4-7-4.4-7-4.5-6.9-4.4-7-4.5-7-4.4-13.9-8.8-7-4.5-6.9-4.4-7-4.4-6.9-4.5-1.4-0.8-5.6 3.5-7 4.3-7 4.3-13.9 8.6-6.9 4.3-7 4.3-7 4.3-7 4.4-6.9 4.3-7 4.3-2.2 1.3c-3.5-2.7-7.5-5.1-11.9-7.1l0.2-0.2 7-4.3 6.9-4.3 7-4.3 6.9-4.3 7-4.3 7-4.3 7-4.3 6.9-4.3 7-4.3 6.9-4.3 7-4.4 7-4.3 5.7-3.5 1.3 0.8 13.9 8.9 6.9 4.4 7 4.5 13.9 8.8 7 4.4 13.9 8.9 7 4.4 7 4.4 13.9 8.9 6.9 4.4 7 4.4 7 4.4 7 4.5 6.9 4.4 7 4.5 13.9 8.8 6.9 4.4 7 4.5 7 4.4 7 4.4 6.9 4.4 7 4.5 7 4.4 6.9 4.4 7 4.5 7 4.4 20.8 13.3 7 4.4 7 4.4 6.9 4.5 7 4.4 7 4.4 13.9 8.8 7 4.5 6.9 4.4 7 4.4 6.9 4.5 7 4.4 7 4.4 7 4.4 6.9 4.5 7 4.4 6.9 4.4 7 4.5 7 4.4 7 4.4 6.9 4.4 7 4.4 6.9 4.5 7 4.4 6.9 4.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m699.1 276.1c38.9 56.1 74.9 114.8 101.2 177.9 10.1 25.1 20.3 50.2 26.4 76.6 24.3 0.1 373.3 7 373.3 10.4-45-0.5-390.3 1.2-435.3 0-97.4 0.1-194.9 0-292.3 0 36.7-46 85.3-80.2 133.1-113.7 22.2-16.1 46-31.4 62.1-54.1 20.9-27.6 32.7-62.3 31.5-97.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m723.8 788.2c-36.8 33.7-81 61.4-130.5 68.4-48.2 7.4-97.9-7.9-137.4-36.6 17.9 6.6 36.8 9.1 55.8 8.9 32.9 1.6 68.8-11.2 87.4-40.7 41.6 0.1 83.1 0.1 124.7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m799.7 788.3c-27.1 43.9-68.3 78.5-115.5 96.8-45.5 17.9-96.4 20.7-143.5 7.9-54-14.3-102.6-49.3-134.1-96.7 26.6 26.4 57 49.4 91.9 62.6 37.8 14.9 80.1 17.6 119.3 6.8 48-12.9 90.1-42.6 125.6-77.4 18.7 0 37.5-0.1 56.3 0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m654.5 340.5c-13.8 23.3-38 37.1-59.2 52.6-60.1 41.2-120.4 85.8-160.4 147.9-44.7 0.6-390.2 0-434.9 0 0-0.4 5.4-0.9 14.9-1.4 4.6-0.2 10.2-0.5 16.6-0.8q5.7-0.2 12.4-0.5c16-0.6 35.5-1.2 56.9-1.8 102.9-3 249.4-5.8 262.9-5.9 4.1-15.8 10.5-30.9 16.5-46.1 2.2 3.8 4.9 13.3 9.7 14.5 9 2.5 18.2-1.1 26.4-4.5 10.6-5 13.5-21.1 16.5-31.5 5.9-22.8 8.7-46.2 14.5-68.9 8.8-37.7 24.6-73.8 47.4-105.1 2.2 11.7 5.5 24.2 14.6 32.5 7.8 7.5 19.8 9.4 30 6.8 27.7-6.7 52.6-26.1 63.3-52.9 15.4-37.3 11.3-79.2 3.1-117.8l-6.2-22.6 18.3 22.6c23.1 26.7 42.2 57.7 50.9 92.2 7.7 30.6 3.3 64.3-14.2 90.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m734.1 492.2c2.2 6.1 4.3 12.2 5.6 18.5 0.9 3.3-4.3 5.1-6 2.3-2.1-4.3-2.8-9.1-4.3-13.6-1.7-4.7-2.3-9.7-4.6-14.1-5-3.8-21.5-11.7-24.2-12.9 0 2.4 0.5 18.8 0.3 24.6 0 4.3 4 6.5 6.6 9.2 4.8 4.6 10 8.8 14.4 13.7 2.3 2.9-2 6.8-4.7 4.6-5.5-4.5-10.4-9.8-15.6-14.6 0 2.2 0 4.5-0.3 6.8 0.4 6.1 0.9 12.2 0.6 18.3-0.3 1.7-1.3 2.2-2.6 2.4-2.2 0.2-4-1.6-4.2-3.8-0.6-7.8-0.3-15.6-0.8-23.4-4.9 4.6-9.2 9.8-14 14.5-0.4 0.6-1 0.9-1.6 1.1-2.4 0.7-4.8-1.5-4.4-4 0.1-0.7 0.4-1.4 1.1-1.9 6-6.8 12.7-12.9 18.6-19.7-0.2-9-0.4-18.1-0.5-27.2-2.1 0.7-15.4 8.1-20.2 11.1-6.6 2.8-7.8 17.4-7.8 17.4-0.9 4.4-1.4 9.1-3.2 13.3-1.6 3-6.7 1.6-6.1-1.9 0.5-4.3 4.1-17.4 4.7-20.1-0.9 0.1-14.8 8.3-21.1 11.8-3.1 2.1-7-3-3.9-5.2 5.4-4.1 20.1-13.2 21.5-14.3-7-0.5-13.7-2.5-20.5-4.3-3.8-0.6-3.3-6.9 0.8-6.4 6.3 0.7 12.4 2.7 18.5 4.3 3.4 0 6.8 2.2 10.2 1.5 6.3-3.1 21.1-12.7 21.8-13-4.4-5.6-23-14.4-26.2-13.4-7.6 2-15.1 4.5-22.6 6.7-2.2 0.7-4.8-0.3-5.6-2.5-0.5-1.2-0.5-2.5 0.8-3.6 6.3-3.1 13.5-4 20-6.6q-1.5-1.2-3-2.4c-5.7-3.2-11.8-5.8-17.3-9.4-3.5-2-0.3-8.1 3.2-6.4 6.5 3 12.8 6.5 18.7 10.5 1-0.7-1.6-13.8-2.6-19.9-0.5-3.4 5.9-4.7 6.6-1.1 1.9 4.3 3 9 4.1 13.6 1.8 4.2 2.6 8.9 4.4 13.2 2.4 2.2 18.1 10.4 23.3 12.6 0.9-8.9-1-17.8 0-26.8l-1.3-1.1c-5.9-6.2-12.6-11.6-18.6-17.8-2.4-1.8-1.5-6 1.6-6.4 2-0.9 3.4 1.4 4.9 2.4 4.4 3.9 8.3 8.4 13.1 11.9q0-3 0-6c0-6.2-0.8-12.4-0.2-18.6 1.1-3.1 5.6-3.3 6.8-0.1 0.7 5.6 0.4 11.3 0.7 16.9q0.2 3.9 0.4 7.8c4.5-4 8.4-8.7 12.5-13 1.5-1 2.9-3.3 5-2.4 2.2 0.3 3.8 3.3 2.4 5.2-3.3 4.4-7.6 7.9-11.2 12-2.7 2.6-4.9 5.9-8.3 7.8 0 5 0.5 24.2 0.5 28.9 5.3-3.3 23.7-14.6 26.1-16 1.2-4.2 2.2-18.8 4.4-25.5 0.7-2 2.9-3.2 4.8-2.4 1.1 0.4 1.9 1.3 2 2.8-1 5.8-3.1 19.4-2.6 20.1 6.3-4 12.4-8.3 19.1-11.6 3.4-1.9 6.4 3.9 3.5 6-6 4.3-12.5 7.9-19 11.6 0.3 0.5 13.8 4.4 19.8 7 1.8 2.3 1 6.9-2.4 6.9-8.8-1.9-17.4-4.8-26.3-6.2-3-0.5-18.5 9.2-23.4 12.8 0.5 0.9 15.7 11.2 19.7 13.1 4 2.4 8.2-1.1 12.3-1.4 6-1.7 11.8-4.2 18-5.2 1.8-0.1 2.7 0.9 3 2.1 0.5 2.1-0.9 4.2-2.9 4.8-5.6 1.5-15.9 4.5-18.3 5.1 0.3 0.5 0.8 1.4 1.1 1.8 6.6 3.8 13.7 6.9 20.1 11.2 3 2-0.5 7.2-3.4 5.4-6.6-3-21.7-9.7-21.8-9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m605.8 515.3c0.9 2.5 1.8 5 2.3 7.6 0.4 1.4-1.7 2.1-2.4 1-0.9-1.8-1.2-3.8-1.8-5.6-0.7-1.9-0.9-4-1.9-5.8-2-1.5-8.8-4.8-9.9-5.3 0 1 0.2 7.7 0.1 10.1 0 1.7 1.7 2.6 2.7 3.7 2 1.9 4.1 3.6 5.9 5.7 1 1.2-0.8 2.7-1.9 1.9-2.3-1.9-4.2-4.1-6.4-6 0 0.9 0 1.8-0.1 2.7 0.2 2.5 0.4 5 0.2 7.5-0.1 0.7-0.5 1-1 1-0.9 0.1-1.7-0.6-1.7-1.5-0.3-3.2-0.2-6.4-0.4-9.6-2 1.9-3.7 4-5.7 5.9q-0.3 0.4-0.7 0.5c-0.9 0.3-1.9-0.6-1.8-1.6 0.1-0.3 0.2-0.6 0.5-0.8 2.4-2.8 5.2-5.3 7.6-8.1-0.1-3.7-0.2-7.4-0.2-11.2-0.8 0.3-6.3 3.4-8.3 4.6-2.7 1.2-3.2 7.1-3.2 7.1-0.3 1.8-0.5 3.8-1.3 5.5-0.6 1.2-2.7 0.6-2.5-0.8 0.2-1.8 1.7-7.1 2-8.2-0.4 0-6.1 3.4-8.7 4.8-1.3 0.9-2.8-1.3-1.6-2.1 2.2-1.7 8.3-5.4 8.8-5.9-2.8-0.2-5.6-1-8.4-1.7-1.5-0.3-1.3-2.9 0.4-2.7 2.5 0.3 5 1.1 7.5 1.8 1.4 0 2.8 0.9 4.2 0.6 2.6-1.3 8.6-5.2 8.9-5.3-1.8-2.3-9.4-5.9-10.7-5.5-3.1 0.8-6.2 1.8-9.3 2.8-0.9 0.2-1.9-0.2-2.3-1.1-0.2-0.5-0.2-1 0.4-1.5 2.6-1.2 5.5-1.6 8.2-2.7q-0.6-0.4-1.2-0.9c-2.4-1.3-4.9-2.4-7.1-3.9-1.5-0.8-0.2-3.3 1.3-2.6 2.6 1.2 5.2 2.7 7.6 4.3 0.4-0.3-0.6-5.7-1.1-8.2-0.2-1.4 2.5-1.9 2.8-0.4 0.7 1.8 1.2 3.7 1.6 5.5 0.8 1.8 1.1 3.7 1.9 5.5 0.9 0.9 7.4 4.2 9.5 5.1 0.3-3.6-0.4-7.3 0-10.9l-0.5-0.5c-2.5-2.6-5.2-4.8-7.7-7.3-1-0.7-0.6-2.4 0.7-2.6 0.8-0.4 1.4 0.6 2 1 1.8 1.6 3.4 3.4 5.4 4.8q0-1.2 0-2.4c0-2.5-0.3-5.1-0.1-7.6 0.4-1.3 2.3-1.4 2.8-0.1 0.3 2.3 0.1 4.6 0.3 7q0 1.5 0.1 3.1c1.9-1.6 3.4-3.5 5.2-5.3 0.5-0.4 1.1-1.3 2-0.9 0.9 0.1 1.6 1.3 0.9 2-1.3 1.9-3 3.3-4.5 5-1.1 1.1-2 2.4-3.4 3.2 0 2 0.2 9.9 0.2 11.8 2.1-1.3 9.7-6 10.7-6.6 0.4-1.7 0.9-7.6 1.8-10.4 0.3-0.8 1.1-1.3 1.9-1 0.5 0.2 0.8 0.6 0.9 1.2-0.4 2.4-1.3 7.9-1.1 8.2 2.6-1.6 5.1-3.4 7.8-4.8 1.4-0.7 2.6 1.6 1.4 2.5-2.4 1.8-5.1 3.3-7.7 4.8 0.1 0.2 5.6 1.8 8.1 2.8 0.7 1 0.4 2.9-1 2.9-3.6-0.8-7.1-2-10.8-2.6-1.2-0.2-7.6 3.8-9.6 5.3 0.3 0.3 6.5 4.5 8.1 5.3 1.6 1 3.3-0.4 5-0.6 2.5-0.7 4.9-1.7 7.4-2.1 0.8 0 1.1 0.4 1.3 0.9 0.2 0.8-0.4 1.7-1.3 1.9-2.2 0.7-6.4 1.9-7.4 2.1 0.1 0.2 0.3 0.6 0.4 0.8 2.7 1.5 5.6 2.8 8.2 4.5 1.3 0.9-0.2 3-1.4 2.3-2.6-1.3-8.8-4-8.9-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m873.2 797.1c0 0.6-0.1 1.2-0.2 1.8-0.3 1.8-1.3 3.5-2.5 4.8-1.7 1.6-4.1 2.7-6.6 2.7h-13c-23.6 44.3-59.2 82-102.1 107.9-49.9 30.6-109.6 44.8-167.9 40.8-62.7-3.8-123.8-29.2-170.6-71-25.1-21.9-45.5-48.6-61.5-77.7h-10.7c-4.5 0-8.2-3.2-9.1-7.5q-0.1-0.8-0.1-1.8c0-2.5 1-4.8 2.7-6.5 1.7-1.7 4-2.7 6.5-2.7h58.4c5.1 0 9.3 4.1 9.3 9.2 0 2.6-1.1 4.9-2.7 6.6-1.7 1.6-4 2.7-6.6 2.7h-1.5c28.7 43.3 71.3 77.4 120.1 95.3 49.7 18.3 105.4 19.9 156 4.5 54.5-16.2 102.5-52.5 133.8-99.8-4.8-0.3-8.7-4.3-8.7-9.3 0-2.5 1-4.8 2.7-6.5 1.7-1.7 4-2.7 6.6-2.7h58.4c5.1 0 9.3 4.1 9.3 9.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m495.4 742.3c0 10.8-5.6 12.9-21.2 12.9-15.7 0-21.3-2.1-21.3-12.9 0-10.8 5.6-12.8 21.3-12.8 15.6 0 21.2 2 21.2 12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m151.5 742.3c0 10.8-5.6 12.9-21.2 12.9-15.7 0-21.3-2.1-21.3-12.9 0-10.8 5.6-12.8 21.3-12.8 15.6 0 21.2 2 21.2 12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s18",
    d: "m0 706.2h1200v72.2h-1200zm80.6 44.8c0-9.1-6.6-13.7-18.8-13.7h-27.4c-3.6 0-5.3-1-5.3-3.5 0-2.6 1.7-3.5 5.3-3.5h34.9l10-13.1h-43.7c-15.2 0-21.6 6.2-21.6 15.6 0 8.7 6 14.5 18.9 14.5h27.4c3.6 0 5.3 1 5.3 3.6 0 2.6-1.7 3.7-5.3 3.7h-38.1l-10 12.9h46.8c15.4 0 21.6-6.2 21.6-16.5zm86.4-8.7c0-17.9-12.3-25.9-36.8-25.9-24.5 0-36.7 8-36.7 25.9 0 18 12.2 26 36.7 26 24.5 0 36.8-8 36.8-26zm69.9 12.3h-38.9v-37.4h-15.6v50.3h44.5zm78-37.4h-15.6v28.4c0 7.1-3.8 9.8-15.8 9.8-16 0-19.1-2.4-19.1-9.8v-28.4h-15.5v28.4c0 15.2 10.4 22.8 34.6 22.8q31.4 0 31.4-22.8zm78.7 0h-57.1l-10 13.1h23.5v37.2h15.6v-37.2h18zm12.5 50.3h15.5v-50.3h-15.5zm104.7-25.2c0-18-12.4-26-36.8-26-24.5 0-36.8 8-36.8 26 0 17.9 12.3 26 36.8 26 24.4 0 36.8-8.1 36.8-26zm74.9-25.1h-14.2v29.5l-30.8-27.6c-2.5-2.3-4.4-2.8-6.3-2.8-4.4 0-8.4 2.8-8.4 9.4v41.8h14.1v-29.6l30.8 27.7c2.4 2.2 4.3 2.7 6.2 2.7 4.5 0 8.6-2.8 8.6-9.5zm82.2 33.8c0-9.1-6.6-13.7-18.9-13.7h-27.3c-3.7 0-5.4-1-5.4-3.5 0-2.6 1.7-3.5 5.4-3.5h34.8l10-13.1h-43.7c-15.2 0-21.5 6.2-21.5 15.6 0 8.7 5.9 14.5 18.9 14.5h27.3c3.7 0 5.3 1 5.3 3.6 0 2.6-1.6 3.7-5.3 3.7h-38l-10 12.9h46.8c15.3 0 21.6-6.2 21.6-16.5zm117.1-14.9c0-11.2-9.1-18.9-24.7-18.9h-31.6l-10.2 13.1h43.3c4.8 0 7.6 2.2 7.6 5.7 0 3.5-2.8 5.8-7.6 5.8h-43.3v25.7h15.5v-12.8h26.3c15.6 0 24.7-7.5 24.7-18.6zm77.9-18.9h-57.2l-10 13.1h23.6v37.2h15.5v-37.2h18zm84.3 0h-19.6l-11.4 13.9c-3.6 4.4-5.3 6.5-6.3 8-1.1-1.5-5.3-6.1-6.9-7.9l-12-14h-20l30.7 33.6v16.7h15.6v-16.6zm103.6 37.3h-38.9v-37.3h-15.6v50.3h44.4zm65.7-37.4h-57.1l-10.1 13.1h23.6v37.2h15.6v-37.2h17.9zm71.2 24.7c0-14.6-12.6-24.7-30.3-24.7h-23.7l-9.9 13.1h33.6c8.5 0 14.9 5.2 14.9 12.2 0 7.2-6.2 12-14.9 12h-18v-18.4h-15.6v31.4h33.6c17.5 0 30.3-11.1 30.3-25.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m588.8 205.8l-42.5 25.1-11.5-19.6c0 0 10.6-29.3-17.4-34.6-0.2 0-0.4-0.1-0.6-0.1l-99.7 61.7-179.6 111.1v183.2c-15.5 0.4-29.7 0.9-41.3 1.3v-209.4l198.1-122.5 102.3-63.3c0.2-1.5 0.1-3-0.3-4.5-0.5-1.9-1.4-4-3-5.9-2.1-2.8-5.5-5.4-10.6-7.4q-0.3-0.1-0.6-0.2c-18.8-7-46.9-5.7-50.3-7.4-3.4-1.7-12-14.5 28.1-16.6 20.3-1 36.9 1.7 49.8 7 4.6 1.9 8.8 4.2 12.5 6.7q4.8 3.3 8.3 7.3c2.3 2.4 4.2 5 5.7 7.8 7 12.7 13.5 23.3 16.8 28.6 0 0 0 0.1 0 0.1 1.3 2.1 1.9 4.6 1.9 7-0.2 6.8 1.5 20.9 16.8 26.6l7.9 2.4z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ad63e4bfd60d51bcca16149f1b1020d.svg";
export { ForwardRef as ReactComponent };